module.exports = __webpack_public_path__ + "img/1-1_08.c7064436.jpg";